/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FetchOrderAsNewModelReq } from '../models/fetch-order-as-new-model-req';
import { FetchOrderAsNewModelResp } from '../models/fetch-order-as-new-model-resp';

@Injectable({
  providedIn: 'root',
})
export class CatalogSyncService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation fetchOrderAsNewModel
   */
  static readonly FetchOrderAsNewModelPath = '/catalog-sync/fetch-model';

  /**
   * Catalog sync
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fetchOrderAsNewModel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fetchOrderAsNewModel$Response(params: {
    body: FetchOrderAsNewModelReq
  }): Observable<StrictHttpResponse<FetchOrderAsNewModelResp>> {

    const rb = new RequestBuilder(this.rootUrl, CatalogSyncService.FetchOrderAsNewModelPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FetchOrderAsNewModelResp>;
      })
    );
  }

  /**
   * Catalog sync
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fetchOrderAsNewModel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fetchOrderAsNewModel(params: {
    body: FetchOrderAsNewModelReq
  }): Observable<FetchOrderAsNewModelResp> {

    return this.fetchOrderAsNewModel$Response(params).pipe(
      map((r: StrictHttpResponse<FetchOrderAsNewModelResp>) => r.body as FetchOrderAsNewModelResp)
    );
  }

}
